'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import FormattedMessage from 'I18n/components/FormattedMessage';

const ExitModal = ({
  onConfirm,
  onReject
}) => {
  return /*#__PURE__*/_jsx(UIConfirmModal, {
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.exitModal.header"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.exitModal.description"
    }),
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.exitModal.confirm"
    }),
    onConfirm: onConfirm,
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.exitModal.reject"
    }),
    onReject: onReject,
    size: "auto"
  });
};

export default ExitModal;